import cx from 'classnames'
import PropTypes from 'prop-types'

import { Typography } from 'common/widgets'
import classNames from './styles.module.scss'


Name.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
}

export default function Name({
  className = undefined,
  children = undefined,
}) {
  return (
    <Typography
      variant="block-title"
      tag="p"
      color="black"
      className={cx(classNames.name, className)}
    >
      {children}
    </Typography>
  )
}
